import * as React from 'react';

/**
 * @description DocumentEdit icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { DocumentEdit } from '@sravni/design-system-icons'
 *
 * <DocumentEdit />
 * ```
 */
const DocumentEdit = React.forwardRef((props, ref) => (React.createElement("svg", { ref: ref, "data-qa": "DocumentEdit", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("path", { d: "M4.958 10.832h5.75M5 13.332h3.242M8.244 17.5H4.142A1.654 1.654 0 0 1 2.5 15.833V4.167c0-.921.735-1.667 1.642-1.667h8.383c.907 0 1.642.746 1.642 1.667v5M16.077 10.588l-5.244 5.244v1.666H12.5l5.244-5.244a.832.832 0 0 0 0-1.178l-.488-.489a.834.834 0 0 0-1.179 0Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M6.25 7.5H5V5h1.25a1.25 1.25 0 0 1 0 2.5Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))));

export { DocumentEdit };
//# sourceMappingURL=DocumentEdit.js.map
